/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.0.12.0 (NJsonSchema v9.13.15.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export interface UserPreferencesDto {
    favoriteApps: UserFavoriteAppDto[];
}

export interface UserFavoriteAppDto {
    appId: string;
    locationCode?: string | null;
}

export interface ProfileDto {
    profileCode: string;
    displayName: string;
}

export interface ProfileDefaultAppsDto {
    profileCode: string;
    defaultAppIds: string[];
}

export interface UserLocation {
    locationCode: string;
    displayName: string;
    suburb: string;
}

export interface ConfigurationDto {
    sideDrawAppCountLimit: number;
}

export interface CategoryDto {
    id: string;
    name: string;
}

export interface CategoryEntryDto {
    name: string;
}

export interface AppTourStateDto {
    showAppTour: boolean;
}

export interface AppTourStateUpdateRequestDto {
    requestedState: AppTourNewStates;
}

export enum AppTourNewStates {
    ShowNextTime = 0, 
    Dismiss = 1, 
}

export interface ApplicationDto {
    id: string;
    name: string;
    description: string;
    moreInformationUrl: string;
    iconUrl: string;
    categories: CategoryDto[];
    urls: ApplicationUrlDto[];
    isLocationSpecific: boolean;
    tags: string[];
    isArchived: boolean;
    profileCodes: string[];
}

export interface ApplicationUrlDto {
    locationCode?: string | null;
    locationName: string;
    url: string;
}

export interface ApplicationEntryDto {
    name: string;
    description: string;
    moreInformationUrl: string;
    urls: ApplicationUrlEntryDto[];
    categoryIds: string[];
    tags: string[];
    profileCodes: string[];
    isArchived: boolean;
}

export interface ApplicationUrlEntryDto {
    locationCode?: string | null;
    url: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}